// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__eAbv3","tyre":"style_tyre__Cc0x1"};